import { Button, DatePicker } from "@heroui/react";
import { addDays } from "date-fns";
import { useCallback, useMemo } from "react";
import {
  CalendarDate,
  fromDate,
  getLocalTimeZone,
} from "@internationalized/date";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

interface MeetingRoomDateControlsProps {
  date: Date;
  onChange: (nextDate: Date) => void;
  className?: string;
}

function toCalendarDate(date: Date) {
  const zoned = fromDate(date, getLocalTimeZone());
  return new CalendarDate(zoned.year, zoned.month, zoned.day);
}

function toDate(value: CalendarDate): Date {
  return new Date(value.year, value.month - 1, value.day);
}

export function MeetingRoomDateControls({
  date,
  onChange,
  className,
}: MeetingRoomDateControlsProps) {
  const dateValue = useMemo(() => toCalendarDate(date), [date]);

  const handleDateChange = useCallback(
    (value: CalendarDate | null) => {
      if (!value) return;
      onChange(toDate(value));
    },
    [onChange],
  );

  const handlePrev = useCallback(() => {
    onChange(addDays(date, -1));
  }, [date, onChange]);

  const handleNext = useCallback(() => {
    onChange(addDays(date, 1));
  }, [date, onChange]);

  return (
    <div
      className={`flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3 ${className ?? ""}`}>
      <Button
        size="sm"
        variant="flat"
        startContent={<FaChevronLeft />}
        className="max-w-fit"
        onClick={handlePrev}>
        Вчера
      </Button>
      <DatePicker
        aria-label="Дата таймлайна"
        value={dateValue}
        onChange={handleDateChange}
        variant="bordered"
        size="sm"
        className="sm:w-auto"
        showMonthAndYearPickers
        label="Дата"
      />
      <Button
        size="sm"
        variant="flat"
        endContent={<FaChevronRight />}
        className="max-w-fit"
        onClick={handleNext}>
        Завтра
      </Button>
    </div>
  );
}
